import { render, staticRenderFns } from "./mobileSidebar.vue?vue&type=template&id=58878c8e&"
import script from "./mobileSidebar.vue?vue&type=script&lang=js&"
export * from "./mobileSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports